var map = {
	"./ar.json": [
		2355,
		355
	],
	"./de.json": [
		7636,
		636
	],
	"./defaultLanguage.json": [
		1739,
		739
	],
	"./en.json": [
		6729,
		729
	],
	"./es-ES.json": [
		3977,
		977
	],
	"./et.json": [
		7000,
		0
	],
	"./fr.json": [
		2755,
		755
	],
	"./it.json": [
		7988,
		988
	],
	"./lt.json": [
		7727,
		727
	],
	"./ru.json": [
		1434,
		434
	],
	"./uk.json": [
		7858,
		858
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1802;
module.exports = webpackAsyncContext;